import { MainMenu } from './MainMenu';

export const Header = () => (
   <header className="main-header">
        <h1>Bem-vindo(a) ao Movie List</h1>
        <MainMenu />
   </header>
)